import * as React from 'react';

import { cn } from '../lib/utils';

export type TextareaProps = { } & React.TextareaHTMLAttributes<HTMLTextAreaElement>;

function Textarea({ ref, className, ...props }: TextareaProps & { ref?: React.RefObject<HTMLTextAreaElement | null> }) {
    return (
        <textarea
            className={cn(
                // Layout
                'flex min-h-[80px] w-full items-center justify-between gap-2 rounded-md',
                // Background & Border
                'border-box border border-input-border bg-transparent',
                // Text
                'px-3 py-2 text-sm',
                // Transition
                'transition duration-100',
                // Placeholder & Hover
                'placeholder:font-normal placeholder:text-muted-foreground hover:border-input-border-hover hover:shadow-input-hover',
                // Focus
                'focus-visible:border-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2',
                // Disabled
                'disabled:cursor-not-allowed disabled:opacity-50',
                // 'border-input-border shadow-input-border-shadow/25 hover:border-input-border-hover hover:shadow-input-border-hover flex min-h-[80px] w-full items-center justify-between gap-2 rounded-md border bg-transparent px-3 py-2 text-sm shadow ring-offset-background transition-colors placeholder:text-muted-foreground focus-visible:border-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50',
                // "flex min-h-[80px] w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
                className,
            )}
            ref={ref}
            {...props}
        />
    );
}
Textarea.displayName = 'Textarea';

export { Textarea };
